import { Schema } from "effect";

/** Preserve each named domain class and its literal status with the same fields. */
export const messageHttpFailure = <Self,>() => <const Tag extends string, const Status extends number>(tag: Tag, status: Status) =>
  Schema.TaggedError<Self>()(tag, { message: Schema.String, status: Schema.tag(status) });
